export default __webpack_public_path__ + "static/media/IMG_20210709_111854_936.9cde9061.jpg";